<div class="container">
  <div class="amplifyBorders">
    <app-add-user/>
  </div>
</div>

